import { createAnimations } from '@tamagui/animations-css';

import { AnimationName } from './animationTypes';

const animationMap: { [k in AnimationName]: string } = {
  fastEaseOut: 'cubic-bezier(0, 1, 1, 1) 100ms',
  easeIn100ms: 'ease-in 100ms',
  // TODO: use tokens for this
  slowEnter: 'cubic-bezier(0.25, 0.1, 0.25, 1) 800ms 400ms',
  middleExit: 'cubic-bezier(0.25, 0.1, 0.25, 1) 640ms',
};

export const animations = createAnimations(animationMap);
